import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/activeClientsSagas";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";

const CrossRegionalVisits = () => {
  const dispatch = useDispatch();
  const includeCrossRegionalVisits = useSelector(
    (state) => state.activeClients.selectedFilters.include_cross_regional_visits
  );

  return (
    <ToggleableButton
      isActive={includeCrossRegionalVisits}
      isRadio
      title="active-clients-cross-regional-visits"
      onClick={(data) => dispatch(actionCreators.updateCrossRegionalVisits(data))}
    />
  );
};

export default CrossRegionalVisits;
